import {BaseArticle, PutArticleStockManagementCalculationResponse} from '@dms/api/warehouse';

export function mapStockCalculationToForm(
  result: PutArticleStockManagementCalculationResponse
): Partial<BaseArticle['stockManagement']> {
  return {
    stockManagementMinQuantity: result.minQuantity,
    stockManagementMaxQuantity: result.maxQuantity,
    currentStockQuantity: result.currentStockQuantity,
    reservationQuantity: result.reservationQuantity,
    returnToSupplierQuantity: result.returnToSupplierQuantity,
    returnToWarehouseQuantity: result.returnToWarehouseQuantity,
    orderRequestsQuantity: result.orderRequestsQuantity,
    orderPendingQuantity: result.orderPendingQuantity,
    orderedQuantity: result.orderedQuantity,
    receiveQuantity: result.receiveQuantity,
    forecastQuantity: result.forecastQuantity,
    toOrderQuantity: result.toOrderQuantity,
  };
}
